import ICoverageByProduct from './CoverageByProduct'


export default interface IProduct {

    productCode?: string,
    productName?: string,
    productDescription?: string,
    lineOfBusinessCode?: string,
    riskElementCode?: string,
    isActive?: boolean,
    isGroupProduct?: boolean,
    isClosedGroup?: boolean,
    isOnlyInGroup?: boolean,
    accessoriesTarificationCode?: string,
    accessoriesTarificationParameters?: string,
    accessoriesFormula?: string,
    accessoriesTaxFormula1?: string,
    accessoriesTaxFormula2?: string,
    accessoriesTaxFormula3?: string,
    accessoriesTaxFormula4?: string,
    accessoriesTaxFormula5?: string,
    accessoriesTaxFormula6?: string,
    isCollectionOfSubElement?: boolean,
    isRenewable?: boolean,
    isAutoRenewalDate?: boolean,
    minimumDuration?: number,
    minimumDurationUnit?: string,
    maximumDuration?: number,
    maximumDurationUnit?: string,
    allowedPaymentFrequency?: string,
    tarificationPropertyName1?: string,
    tarificationPropertyText1?: string,
    tarificationPropertyDescription1?: string,
    tarificationValueList1?: string,
    tarificationPropertyName2?: string,
    tarificationPropertyText2?: string,
    tarificationPropertyDescription2?: string,
    tarificationValueList2?: string,
    tarificationPropertyName3?: string,
    tarificationPropertyText3?: string,
    tarificationPropertyDescription3?: string,
    tarificationValueList3?: string,
    tarificationPropertyName4?: string,
    tarificationPropertyText4?: string,
    tarificationPropertyDescription4?: string,
    tarificationValueList4?: string,
    tarificationPropertyName5?: string,
    tarificationPropertyText5?: string,
    tarificationPropertyDescription5?: string,
    tarificationValueList5?: string,
    infoPropertyName1?: string,
    infoPropertyText1?: string,
    infoPropertyDescription1?: string,
    infoValueList1?: string,
    infoPropertyName2?: string,
    infoPropertyText2?: string,
    infoPropertyDescription2?: string,
    infoValueList2?: string,
    infoPropertyName3?: string,
    infoPropertyText3?: string,
    infoPropertyDescription3?: string,
    infoValueList3?: string,
    infoPropertyName4?: string,
    infoPropertyText4?: string,
    infoPropertyDescription4?: string,
    infoValueList4?: string,
    infoPropertyName5?: string,
    infoPropertyText5?: string,
    infoPropertyDescription5?: string,
    infoValueList5?: string,
    cPDocumentCode?: string,
    isAutoBillingPayment?: boolean,
    isAdvanceOnBillingAllowed?: boolean,
    maxUnpaidBillingInMonth?: number,
    isProductCommissionLevel?: boolean,
    commissionSchemaCode?: string,
    maxCommissionEscomptedDuration?: number,
    escompteInterestRate?: number,
    zilmerDuration?: number,
    effectiveDate?: Date,
    cancellationDate?: Date,
    cancellationPurpose?: string,
    lifetermCapitalAssemblyCode?: string,
    lifetermCapitalClassName?: string,
    termCapitalAssemblyCode?: string,
    termCapitalClassName?: string,
    classification1?: string,
    classification2?: string,
    classification3?: string,
    classification4?: string,
    extraBillingName1?: string,
    extraBillingName2?: string,
    extraBillingName3?: string,
    extraBillingName4?: string,
    extraBillingName5?: string,
    isPaymentProduct?: boolean,
    accessoriesMode?: string,
    partialSurrenderAllowed?: boolean,
    fullSurrenderAllowed?: boolean,
    advanceAllowed?: boolean,
    accessoriesSharingSchemaCode?: string,
    extraCommissionSchemaCode?: string,
    maturityAllowed?: boolean,
    maturityByArrearsAllowed?: boolean,
    textValue1?: string,
    textValue2?: string,
    textValue3?: string,
    textValue4?: string,
    textValue5?: string,
    numericValue1?: number,
    numericValue2?: number,
    numericValue3?: number,
    numericValue4?: number,
    numericValue5?: number,
    claimAllowed?: boolean,
    claimWhitoutBillingAllowed?: boolean,
    isPartialSurrenderAddendum?: boolean,
    isExceptionalPremiumAllowed?: boolean,
    isExceptionalPremiumAddendum?: boolean,
    isAutoPaymentDuration?: boolean,
    productInitial?: string,
    contractnumberValidationFormat?: string,
    isPremiumPaymentValidationActive?: boolean,
    isBillingAndPremiumUsed4PM?: boolean,
    generateAllBillingAtValidation?: boolean,
    isCommissionPaidAfterACK?: boolean,
    isCommissionPaidAfterReturn?: boolean,
    minorChildAgeMin?: number,
    minorChildAgeMax?: number,
    majorChildAgeMin?: number,
    majorChildAgeMax?: number,
    minAgeLimit?: number,
    maxAgeLimit?: number,
    maxAgeLimitWarning?: number,
    insurerMinAgeLimit?: number,
    insurerMaxAgeLimit?: number,
    insurerMaxAgeLimitWarning?: number,
    objectReference?: string,
    rowState?: string,
    userWhoNew?: number,
    userWhoLastUpdate?: number,
    lastEnterDate?: Date,
    companyCode?: number,

    coverages: ICoverageByProduct[]
  }


  export const defaultProduct: IProduct = {
    productCode: '',
    coverages: [],
  }

